import { dataShortVideoSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShortVideoSolid = /*#__PURE__*/createIcon(dataShortVideoSolid)
export default IconShortVideoSolid
